import { User } from "oidc-client-ts";
import { ReactElement, createContext } from "react";

export const DEFAULT_CONTEXT: AuthContextValue = {
  isAuthenticated: false,
  user: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSignIn: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSignOut: () => {},
  removeUser: null,
  isLoading: false,
  error: null,
};

export interface AuthContextValue {
  isAuthenticated: boolean;
  user: User | undefined;
  onSignIn: () => void;
  onSignOut: () => void;
  removeUser: () => Promise<void>;
  accessToken?: string;
  tokenType?: string;
  isLoading: boolean;
  error: Error;
  activeNavigator?: string;
}

export interface AuthContextProviderProps {
  children: ReactElement | ReactElement[];
}

export const AuthContext = createContext<AuthContextValue>(DEFAULT_CONTEXT);
